'use client';
import { useCustomer } from '@hooks/customer';
import DynamicComponent from '@repo/ui/src/components/DynamicComponent';
import { SeoProps } from '@repo/ui/src/types/seo';
import Unauthed from '@views/Account/_Unauthed';
import dynamic from 'next/dynamic';
import AccountLayout, { AccountLayoutType } from './Layout';

export interface AccountProps {
  layout: AccountLayoutType;
  header: string;
  description?: string;
  content?: Array<any>;
  contentRows?: { components: Array<any> };
  seo: SeoProps;
}

const OrderHistory = dynamic(() => import('./OrderHistory'));
const AccountOrderDetail = dynamic(() => import('./AccountOrderDetail'));
const CommunicationPreferences = dynamic(() => import('./CommunicationPreferences'));
const AccountProfile = dynamic(() => import('./Profile'));
const AccountDevice = dynamic(() => import('./AccountDevice'));
const SideBySide = dynamic(() => import('@repo/ui/src/components/SideBySide'));
const GeneralCarousel = dynamic(() => import('@components/carousels/GeneralCarousel'));

const components = {
  'https://traeger.com/v2/orderHistory.json': OrderHistory,
  'https://traeger.com/v2/orderDetail.json': AccountOrderDetail,
  'https://traeger.com/v2/communicationPreferences.json': CommunicationPreferences,
  'https://traeger.com/v2/userSettings.json': AccountProfile,
  'https://traeger.com/v2/accountDevice.json': AccountDevice,
};

const contentRowComponents = {
  'https://traeger.com/v2/sideBySide.json': SideBySide,
  'https://traegergrills.com/data/contentTypes/generalReferenceCarousel.json': GeneralCarousel,
};

const Account = ({ layout, content, contentRows, header, description, seo }: AccountProps) => {
  const { data: user } = useCustomer();

  return !user ? (
    <Unauthed />
  ) : (
    <>
      <AccountLayout layout={layout} header={header} description={description} seo={seo}>
        {content?.map((props: any) => (
          <DynamicComponent
            key={props?._meta?.deliveryId}
            _componentTypes={components}
            {...props}
            noPadding={true}
          />
        ))}
      </AccountLayout>
      {contentRows?.components?.length && (
        <div className="tw-px-6 md:tw-px-20 tw-bg-warm-200">
          {contentRows.components.map((props: any) => (
            <DynamicComponent
              key={props?._meta?.deliveryId}
              _componentTypes={contentRowComponents}
              {...props}
              noPadding={true}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default Account;
